"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var urls_1 = require("pbs-stdlib/urls");
function getJson(url) {
    return fetch(url, { credentials: "same-origin" });
}
exports.getJson = getJson;
function postJson(url, data, getCsrfInfo) {
    var _a;
    var csrfInfo = getCsrfInfo ? getCsrfInfo() : null;
    var headers = __assign({ "Content-Type": "application/json" }, (csrfInfo && (_a = {}, _a[csrfInfo.headerName] = csrfInfo.requestToken, _a)));
    return fetch(url, {
        method: "POST",
        body: JSON.stringify(data),
        headers: headers,
        credentials: 'same-origin'
    });
}
exports.postJson = postJson;
function postFormData(url, data, getCsrfInfo) {
    var _a;
    var csrfInfo = getCsrfInfo ? getCsrfInfo() : null;
    var headers = __assign({}, (csrfInfo && (_a = {}, _a[csrfInfo.headerName] = csrfInfo.requestToken, _a)));
    return fetch(url, {
        method: "POST",
        body: data,
        headers: headers,
        credentials: "same-origin"
    });
}
exports.postFormData = postFormData;
function urlWithData(url, data) {
    var params = urls_1.createURLSearchParams(data);
    var doesUrlContainAQueryString = url.indexOf("?") >= 0;
    if (doesUrlContainAQueryString) {
        var isLastCharacterAQuestionMark = url.indexOf("?") == url.length - 1;
        return isLastCharacterAQuestionMark ? url + params.toString() : url + "&" + params.toString();
    }
    else
        return url + "?" + params.toString();
}
exports.urlWithData = urlWithData;
function withStandardErrorHandling(promise, errorHandlers) {
    return promise.catch(function (reason) {
        errorHandlers.handleNetworkError();
        throw reason;
    })
        .then(function (response) {
        if (response.ok) {
            return response.json();
        }
        else if (response.status === 404) {
            errorHandlers.handle404Error();
            throw response.status;
        }
        else if (response.status === 403) {
            errorHandlers.handle403Error();
            throw response.status;
        }
        else if (response.status === 401) {
            errorHandlers.handle401Error();
            throw response.status;
        }
        else {
            errorHandlers.handle500Error();
            throw response.status;
        }
    })
        .then(function (responseJson) { return responseJson; });
}
exports.withStandardErrorHandling = withStandardErrorHandling;
